import dayjs from 'dayjs'
import Link from 'next/link'
import { TJournal } from '~shared/api/getJournalsData/types'
import { Clock2Icon } from '~shared/icons/clock2'
import { cn } from '~shared/utils/cn'
import Image from 'next/image'
import { replacePrepositionsWhitespaces } from '~shared/utils/replace-prepositions-whitespaces'
import { getJournalPath } from '~shared/utils/getJournalPath'

export const JournalCard = ({
  model,
  className
}: {
  model: TJournal
  className?: string
}) => (
  <div
    className={cn(
      'relative justify-between bg-secondary rounded-[24px] overflow-hidden group',
      className
    )}>
    <Link
      href={getJournalPath(model?.tag?.slug, model?.slug)}
      prefetch={false}>
      <div className='relative rounded-[24px] overflow-hidden h-[203px] bg-tertiary'>
        <Image
          src={model?.image?.url || ''}
          alt={model?.image?.alternativeText || model.name || ''}
          fill
          className='object-cover scale-110 group-hover:scale-125 transition-transform duration-300'
        />
      </div>

      <div className='p-6 pt-0 flex flex-col pb-[67px]'>
        <span
          className='flex items-center justify-center mt-6 self-start text-[16px] leading-[1.2] px-[10px] h-[37px] text-white rounded-[24px]'
          style={{ backgroundColor: model?.tag?.color || 'black' }}>
          {model?.tag?.name}
        </span>
        <p className='overflow-hidden mt-6 font-medium text-[16px] md:text-[20px] xl:text-[24px] tracking-[-0.01em] leading-[1] line-clamp-3'>
          {replacePrepositionsWhitespaces(model.name || '')}
        </p>
      </div>

      <div className='absolute left-6 bottom-6 flex gap-6 mt-auto text-[14px] md:text-[16px] leading-[1.2] text-[#6A6A6A]'>
        <p>{dayjs(model.createdDate).format('DD.MM.YYYY')}</p>
        <div className='whitespace-nowrap flex items-center gap-[4px]'>
          <Clock2Icon />
          {`${Number(model.time?.split(':')[1] || 5)} мин.`}
        </div>
      </div>
    </Link>
  </div>
)

export const JournalMainCard = ({ model }: { model: TJournal }) => (
  <Link
    href={getJournalPath(model?.tag?.slug, model?.slug)}
    prefetch={false}
    className='flex flex-col lg:flex-row gap-6 lg:gap-8 text-inherit no-underline group mt-10'>
    <div className='flex flex-col gap-4 py-[16px]'>
      <span
        className='flex items-center justify-center self-start text-[16px] leading-[1.2] px-[10px] h-[37px] text-white rounded-[24px]'
        style={{ backgroundColor: model?.tag?.color || 'black' }}>
        {model?.tag?.name}
      </span>
      <p className='hover:text-[#3a52ee] text-[30px] xl:text-[36px] font-bold leading-tight duration-300'>
        {replacePrepositionsWhitespaces(model.name || '')}
      </p>
      <p className='text-[18px] text-gray-700 leading-relaxed'>
        Узнайте что-то новое для себя в самой свежей статье от МИТМ института
      </p>
      <div className=' flex gap-6 mt-auto text-[14px] md:text-[16px] leading-[1.2] text-[#6A6A6A]'>
        <p>{dayjs(model.createdDate).format('DD.MM.YYYY')}</p>
        <div className='whitespace-nowrap flex items-center gap-[4px]'>
          <Clock2Icon />
          {`${Number(model.time?.split(':')[1] || 5)} мин.`}
        </div>
      </div>
    </div>
    <div className='relative w-full lg:w-1/2 shrink-0 overflow-hidden rounded-[24px]'>
      <Image
        src={model?.image?.url || ''}
        alt={model?.image?.alternativeText || model.name || ''}
        width={800}
        height={500}
        className='w-full object-cover object-center aspect-[3/2] group-hover:scale-105 transition-transform duration-300'
      />
    </div>
  </Link>
)
